@if (!hideFooter) {
  <div class="d-flex justify-center items-center" id="footer">
    @if (impressumUrl) {
      <a [href]="impressumUrl" [innerText]="'footer.imprint' | translate" target="_blank"></a>
    }
    @if (dataPrivacyUrl && impressumUrl) {
      <a>•</a>
    }
    @if (dataPrivacyUrl) {
      <a [href]="dataPrivacyUrl" [innerText]="'footer.dataPrivacy' | translate" target="_blank"></a>
    }
  </div>
}
